import { clearUserScopedStorage } from "@/lib/userScopedStorage";

/**
 * Inactivity-timeout logout handler used by App.tsx's Router.
 *
 * Clears the current user's user-scoped localStorage BEFORE redirecting to
 * /api/logout so a subsequent user on a shared browser cannot observe the
 * previous user's UI state. No-op when unauthenticated — an idle timer firing
 * on the landing page must never redirect or touch storage.
 */
export function performInactivityLogout(
  isAuthenticated: boolean,
  userId: string | null | undefined,
  redirect: () => void = () => {
    window.location.href = "/api/logout";
  },
): void {
  if (!isAuthenticated) return;
  clearUserScopedStorage(userId);
  redirect();
}
